import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/interfaces/base-entity';
import {
  CorpacerosWarehouseMappingDTO,
  SaveCorpacerosWarehouseMappingCommand,
} from '../models/corpaceros-warehouse-mapping.models';

@Injectable({
  providedIn: 'root',
})
export class CorpacerosWarehouseMappingService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.host}/api/CorpacerosWarehouseMapping`;

  getByCompany(companyId: number): Observable<ApiResponse<CorpacerosWarehouseMappingDTO[]>> {
    return this.http.get<ApiResponse<CorpacerosWarehouseMappingDTO[]>>(`${this.baseUrl}/byCompany/${companyId}`);
  }

  save(command: SaveCorpacerosWarehouseMappingCommand): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.baseUrl}/save`, command);
  }

  delete(id: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.baseUrl}/delete/${id}`);
  }
}
